export const isServer = !(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement &&
  window.document.addEventListener
)

export const isClient = !isServer

export const renderNull = () => null
